import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
import { Lang } from './types';
const options: {
  value: Lang;
  label: string;
}[] = [{
  value: 'es',
  label: 'ES'
}, {
  value: 'en',
  label: 'EN'
}];
type LanguageToggleProps = {
  className?: string;
  offsetColor?: string;
};
export function LanguageToggle({
  className = '',
  offsetColor = 'focus-visible:ring-offset-[#faf0e7]'
}: LanguageToggleProps) {
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  const pillId = React.useId();
  return <div role="group" aria-label={t.switchLabel} className={`relative inline-flex items-center rounded-full border border-metallic-border bg-warm-white/70 p-0.5 ${className}`} data-id="element-196" data-mp="mgeefdemd396">
      {options.map(option => {
      const isActive = option.value === lang;
      return <button key={option.value} type="button" onClick={() => setLang(option.value)} aria-pressed={isActive} className={`relative rounded-full px-2.5 py-1 font-body text-[10px] font-semibold uppercase tracking-[1.5px] outline-none transition-colors focus-visible:ring-2 focus-visible:ring-champagne ${offsetColor} ${isActive ? 'text-white' : 'text-champagne-deep hover:text-gold'}`} data-id="element-197" data-mp="22u4fscectdf4">
            {isActive && <motion.span layoutId={`language-toggle-pill-${pillId}`} transition={{
          type: 'spring',
          stiffness: 420,
          damping: 34
        }} aria-hidden="true" className="metallic-gold-surface absolute inset-0 rounded-full border border-metallic-border" data-id="element-198" data-mp="1nfak42rk0458" />}
            <span className="relative" data-id="element-199" data-mp="14m6x308ucpjl">{option.label}</span>
          </button>;
    })}
    </div>;
}